import { ingredientField } from '../../formFields';

const texts = {
  addIngredient: 'Add Ingredient',
  allergensTitle: 'Allergens',
  allergensLockedHint: 'Set from the selected ingredient',
  allergensNoneHint: 'None',
  allergensNoneLockedHint: 'No allergens — set from the selected ingredient',
  exampleImageAlt: 'Ingredient example',
  title: 'Ingredients',
  field: {
    [ingredientField.AMOUNT]: {
      label: 'Amount',
    },
    [ingredientField.UNIT]: {
      label: 'Unit',
    },
    [ingredientField.NAME]: {
      label: 'Ingredient',
    },
    [ingredientField.PREPARATION_COMMENT]: {
      label: 'Prep Comment',
    },
    [ingredientField.ALLERGEN_TAGS]: {
      label: 'Allergens',
    },
  },
  autocomplete: {
    addFreeform: 'Add freeform ingredient:',
    caloriesLabel: 'cal / 100g',
    proteinLabel: 'P:',
    carbsLabel: 'C:',
    fatLabel: 'F:',
    per100gSuffix: '/ 100g',
  },
};

export default texts;
